import DailySummaryTable from './daily-summary-table';

export default DailySummaryTable;
